export interface CockpitRequestToken {
  sequence: number;
  signal: AbortSignal;
}

export class CockpitRequestCoordinator {
  private sequence = 0;
  private active: AbortController | null = null;
  private lastSuccessAt: number | null = null;

  begin(): CockpitRequestToken {
    this.active?.abort();
    this.active = new AbortController();
    return { sequence: ++this.sequence, signal: this.active.signal };
  }

  hasActive(): boolean {
    return this.active !== null && !this.active.signal.aborted;
  }

  isCurrent(token: CockpitRequestToken): boolean {
    return token.sequence === this.sequence && !token.signal.aborted;
  }

  succeed(token: CockpitRequestToken, now: number): boolean {
    if (!this.isCurrent(token)) return false;
    this.lastSuccessAt = now;
    this.active = null;
    return true;
  }

  finish(token: CockpitRequestToken): void {
    if (this.isCurrent(token)) this.active = null;
  }

  isStale(now: number, thresholdMs: number): boolean {
    return (
      this.lastSuccessAt !== null && now - this.lastSuccessAt >= thresholdMs
    );
  }

  cancel(): void {
    this.sequence += 1;
    this.active?.abort();
    this.active = null;
  }
}
